import React from 'react';
import TimelineEvent from './TimelineEvent';
import './CustomTimeline.scss';

const CustomTimeline = ({ events, onEventClick }) => {
  if (!events || events.length === 0) {
    return (
      <div className="custom-timeline-empty">
        <p>No events to display</p>
      </div>
    );
  }

  return (
    <div className="custom-timeline">
      <div className="timeline-line"></div>
      <div className="timeline-events">
        {events.map((event, index) => (
          <TimelineEvent
            key={index}
            event={event}
            onClick={() => onEventClick(event.type, event.id, event.studyFull, event.sideFull, event.stage)}
            isFirst={index === 0}
            isLast={index === events.length - 1}
          />
        ))}
      </div>
    </div>
  );
};

export default CustomTimeline;